module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Tilda Balsley, Akemi Gutierrez\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Akemi Gutierrez was an assistant animator for Walt Disney Features, where her films included "), _c('I', [_vm._v("Mulan")]), _vm._v(", "), _c('I', [_vm._v("Pocahontas")]), _vm._v(", and "), _c('I', [_vm._v("Tarzan")]), _vm._v(". Now a full-time children’s book illustrator, drawing and painting are her favorite things to do. Akemi lives in Los Angeles, California.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/XQ0fmT/tc-custom/9781512491067.jpg?1719982172217",
      "alt": "This image is the cover for the book Lotsa Matzah"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Lotsa Matzah\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('i', [_c('b', [_vm._v("With matzah, we remember well / The Seder story we all tell. ")])])]), _c('p', [_c('i', [_c('b')]), _vm._v("A rhyming introduction to Passover’s traditional food, with children eating and enjoying “lotsa matzah” many different ways during the holiday.")]), _c('p', [_vm._v("Introduce young children to Jewish life with Very First Board Books!")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Kar-Ben\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0